import React from "react";
import { Label } from "reactstrap";
import Required from "./Required";
import MyLabel from "./MyLabel";

const MyTextArea = ({ row,cols,title, name, register, watch, trigger, errors, handleChange, setValue, placeholder,required,min,max,disabled }) => {
  return (
    <div className="form-group  ">
     <MyLabel name={name} title={title} required={required}/>
      <div className="form-control-wrap">
        <textarea
        disabled={disabled}
          placeholder={placeholder}
          type="text"
          id={name}
          rows={row}
          cols={cols}
          {...register(name, {
            required: {
              value: required,
              message: `${title} is required`,
            },
            // pattern: {
            //   value: /^(?!\s*$)[a-zA-Z /.]*$/,
            //   message: "Only alphabets are allowed",
            // },
            minLength: {
              value: min,
              message: `${title} must be at least ${min} characters long`,
            },
            maxLength: {
              value: max,
              message: `${title} cannot exceed ${max} characters`,
            },
          })} 
           className={`form-control ${errors?.[name] ? "is-invalid" : ""}`}
          value={watch(name)}
          onChange={(e) => {
            setValue(name, e.target.value);
            trigger(name); // Trigger validation
          }} 
        />
        {errors[name] && (
          <span
            className="invalid"
            style={{
              color: "#e85347",
              fontSize: "11px",
              fontStyle: "italic",
            }}
          >
            {errors[name]?.message}
          </span>
        )}
      </div>
    </div>
  );
};

export default MyTextArea;
